// extracted by mini-css-extract-plugin
export var measureBox = "_bx-0";